export const MY_FILES_PATH = '/my-files';
export const PROFILE_PATH = '/profile';
export const COMMUNITY_PATH = '/community';
export const SUPPORT_PATH = '/support';
export const DOCUMENTATION_PATH = '/documentation';
export const DEPOSIT_PATH = '/deposit';
export const TERMS_OF_SERVICE_PATH = '/terms';
export const PRIVACY_POLICY_PATH = '/privacy';
